import { render, staticRenderFns } from "./ContentAdditionalBranch.vue?vue&type=template&id=5027b110"
import script from "./ContentAdditionalBranch.vue?vue&type=script&lang=js"
export * from "./ContentAdditionalBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports